import { useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';

import { AcContainer } from '@atoms';
import { ROUTES } from '@constants';
import { AcLoader } from '@components';
import { withStore } from '@stores';

import { Heading } from '@utrecht/component-library-react/dist/css-module';
import { UnorderedList, UnorderedListItem } from '@utrecht/component-library-react';

const AcSearch = ({ store: { pages } }) => {
  const { all_pages } = pages;

  useEffect(() => {
    pages.fetchPages();
  }, []);

  if (!all_pages) {
    return <AcLoader />;
  }

  return (
    <AcContainer spacing='lg'>
      <Heading level={1}>Sitemap</Heading>

      <UnorderedList>
        {all_pages.map((page) => (
          <UnorderedListItem>
            <Link to={`/${page.slug}`}>{page.name}</Link>
          </UnorderedListItem>
        ))}
        {Object.values(ROUTES)
          .filter(
            (route) =>
              route.component && !route.path.includes(':') && route.path !== '/'
          )
          .map((route) => (
            <UnorderedListItem>
              <Link to={route.path}>{route.name}</Link>
            </UnorderedListItem>
          ))}
      </UnorderedList>
    </AcContainer>
  );
};

export default withStore(observer(AcSearch));
